export default {"src":"/_next/static/media/top_logo.f53a2f0c.svg","height":25,"width":55,"blurWidth":0,"blurHeight":0};